var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/isarray/index.js
 ** module id = 991
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/isarray/index.js
 ** module id = 991
 ** module chunks = 1
 **/